<div
    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-min-w-768px"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            {{ i18n._122_CHANGE_PROFILE_PICTURE | translate }}
        </div>
        <button
            type="button"
            class="close"
            [attr.aria-label]="i18n._763_CLOSE | translate"
            (click)="_dialogRef.close(null)"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-7">
                    <p>
                        {{
                            i18n._123_PLEASE_CHOOSE_A_PICTURE_FOR_YOUR_PROFILE_
                                | translate
                        }}
                    </p>
                    <p>
                        {{
                            i18n._124_YOU_CAN_ONLY_UPLOAD_JPEG_FILES_
                                | translate
                        }}
                    </p>
                    <div class="form-group">
                        <input
                            type="file"
                            accept=".jpg,.jpeg"
                            (change)="onPhotoChanged($event)"
                        />
                    </div>
                </div>
                <div class="col-12 col-sm-5 text-center">
                    <div class="cmps-profile-picture">
                        <img
                            [src]="photoUrl"
                            alt
                            *ngIf="photoUrl"
                        />
                        <cmps-icon
                            class="cmps-cdk-transform-scale-8"
                            svgIcon="account-circle"
                            *ngIf="!photoUrl"
                        ></cmps-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            (click)="_dialogRef.close(null)"
        >
            {{ i18n._121_CANCEL | translate }}
        </button>
        <button
            type="button"
            class="btn btn-primary"
            (click)="_onAcceptClick()"
        >
            {{ i18n._120_ACCEPT | translate }}
        </button>
    </div>
</div>
